import React from 'react';
import { PublicLayout } from '../../components/PublicLayout';
import { PublicPageSeo } from '../../components/PublicPageSeo';
import { RelatedLinks } from '../../components/RelatedLinks';
import { getContent } from '../../content/i18n';
import { useLocale, useLocalizedPath } from '../../hooks/useLocale';

type LegalType = 'privacy' | 'terms';

interface LegalPageProps {
  type: LegalType;
}

export const LegalPage: React.FC<LegalPageProps> = ({ type }) => {
  const locale = useLocale();
  const localizedPath = useLocalizedPath();
  const content = getContent(locale);
  const legal = type === 'privacy' ? content.privacy : content.terms;
  const homePath = locale === 'en' ? '/en' : '/';
  const pagePath = locale === 'en' ? `/en/${type}` : `/${type}`;

  return (
    <>
      <PublicPageSeo
        breadcrumbs={[
          { name: content.common.home, path: homePath },
          { name: legal.title, path: pagePath },
        ]}
      />
      <PublicLayout
        breadcrumbs={[
          { label: content.common.home, href: localizedPath('/') },
          { label: legal.title },
        ]}
      >
        <section className="py-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-12">{legal.title}</h1>
          <div className="space-y-8">
            {legal.sections.map((section) => (
              <div key={section.title}>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">{section.title}</h2>
                <p className="text-gray-600 dark:text-gray-300 leading-relaxed">{section.content}</p>
              </div>
            ))}
          </div>
        </section>

        <RelatedLinks
          links={[
            { label: locale === 'zh' ? '关于我们' : 'About', href: '/about' },
            {
              label: type === 'privacy' ? (locale === 'zh' ? '服务条款' : 'Terms') : (locale === 'zh' ? '隐私政策' : 'Privacy'),
              href: type === 'privacy' ? '/terms' : '/privacy',
            },
            { label: locale === 'zh' ? '帮助中心' : 'Help', href: '/help' },
          ]}
        />
      </PublicLayout>
    </>
  );
};

export const PrivacyPage: React.FC = () => <LegalPage type="privacy" />;
export const TermsPage: React.FC = () => <LegalPage type="terms" />;
